import OpencellAPI from '../OpencellAPI';
import AuthorizationService from './AuthorizationService';

export default class BaseService {
	constructor(provider) {
		this.provider = provider || provider;
		this.useMockup = false;
	}

	get opencellAPI() {
		return new OpencellAPI(OPENCELL_PATH, AuthorizationService.auth, this.provider);
	}

	get opencellAPI_selfWS() {
		return new OpencellAPI(OPENCELL_PATH, null, this.provider);
	}

	notifyActionSuccess(action, entity) {
		console.log("successfully " + action + " entity " + entity);
	}

	notifyActionFailure(action, entity) {
		console.log("failed " + action + " entity " + entity);
	}

	forgotPassword(email) {
		console.log("email: " + email);
		this.opencellAPI_selfWS.forgotPassword(email);
	}

	login(data, callback) {
		this.opencellAPI.find_customer(data.code)
			.then(response => {
					if (callback) {
						callback('success', response);
					}
				}
			)
			.catch(error => {
				this.dataList.pop();
				if (callback) {
					callback('error', error);
				}
			});
	}

	customer(data, callback) {
		this.opencellAPI.find_customer(data)
			.then(response => {
					if (callback) {
						callback('success', response);
					}
				}
			)
			.catch(error => {
				this.dataList.pop();
				if (callback) {
					callback('error', error);
				}
			});
	}

	contact(data, callback) {
		this.opencellAPI.contact(data)
			.then(response => {
					if (callback) {
						callback('success', response);
					}
				},
				error => {
					this.dataList.pop();
					if (callback) {
						callback('error', error);
					}
				}
			);
	}

	findUser(code, callback) {
		this.opencellAPI.find_user(code)
			.then(response => {
					if (callback) {
						callback('success', response);
					}
				},
				error => {
					if (callback) {
						callback('error', error);
					}
				}
			);
	}

}



// WEBPACK FOOTER //
// ./src/opencell/services/BaseService.js